import React, { useEffect, useState } from "react";
import { data, useNavigate } from "react-router-dom";
import Preloader from "../Preloder/Preloader";
import axios from "axios";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const navigate = useNavigate();
  const apikey = process.env.REACT_APP_API_KEY;
   


   useEffect(() => {
  const username = localStorage.getItem("username");
  const sex = localStorage.getItem("sex");

  // console.log("username:", username, "sex:", sex);

  if (username && sex) {
    navigate("/user/dashboard");
  }
}, []);

const handleLogin = async (e) => {
  e.preventDefault();

  const datas = {
    username,
    password,
  };

  try {
    const response = await axios.post(
      "https://matrimony.bugchat.in/api/login",
      datas,
      {
        headers: {
          "x-api-key": apikey,
          "Content-Type": "application/json",
        },
      }
    );

    // console.log(response.data.user.username, response.data.user.sex);
   console.log(response.data.user.full_name)
    // Save to loca  lStorage (fixed keys)
    localStorage.setItem("username", response.data.user.username);
    localStorage.setItem("sex", response.data.user.sex);
    localStorage.setItem("full_name",response.data.user.full_name)

    if (response.data.message === "Login Successful") {
      navigate("/user/dashboard");
    }
  } catch (err) {
    console.error("Login failed:", err);
  }
};


  return (
  <>
  <Preloader/>
    <div
      style={{
        minHeight: "100vh",
        backgroundImage:
          "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/images/gallery/matri.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Arial, sans-serif",
      }}
    >
      
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          padding: "35px",
          borderRadius: "12px",
          width: "100%",
          maxWidth: "400px",
          boxShadow: "0 6px 15px rgba(0,0,0,0.3)",
          backdropFilter: "blur(3px)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "25px",
            color: "#2c3e50",
            fontSize: "1.8rem",
          }}
        >
          Login to Continue
        </h2>

        <form onSubmit={handleLogin}>
          {/* Username */}
          <div style={{ marginBottom: "18px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              User Name
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
              required
            />
          </div>

          {/* Password */}
          <div style={{ marginBottom: "18px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
              required
            />
          </div>

          {/* Remember me & Forgot password */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "18px",
              fontSize: "14px",
            }}
          >
            <label>
              <input
                type="checkbox"
                checked={remember}
                onChange={() => setRemember(!remember)}
                style={{ marginRight: "6px" }}
              />
              Remember me?
            </label>
          <button
        onClick={() => navigate("/forgotpasscode")}
        className="btn btn-link mt-2"
      >
        Forgot Passcode?
      </button>
          </div>

          {/* Login Button */}
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: "#3498db",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "17px",
              cursor: "pointer",
            }}
          >
            Login
          </button>
        </form>
      </div>
    </div>
  </>
  );
};

export default Login;